/**
 * Last camera per activity id, so the map comes back where the user left
 * it when it's recreated -- on a theme switch, and on the remount that
 * follows every committed edit (the workspace shows "Loading" while the
 * edited history replays). Without this, every dragged point would zoom
 * the map back out to the whole route. Module-level on purpose: it must
 * outlive the map component instance. In memory only, not persisted.
 */
export interface CameraState {
  center: [number, number]
  zoom: number
  bearing: number
  pitch: number
}

const cameraMemory = new Map<string, CameraState>()

export function getRememberedCamera(activityId: string): CameraState | undefined {
  return cameraMemory.get(activityId)
}

export function rememberCamera(activityId: string, camera: CameraState): void {
  cameraMemory.set(activityId, camera)
}

/** Forget all remembered cameras (tests). */
export function clearMapCameraMemory(): void {
  cameraMemory.clear()
}
